// Measurement IDs are public browser configuration, not secrets.
export const googleAnalyticsId =
  import.meta.env.VITE_GOOGLE_ANALYTICS_ID ?? "G-2X631DW2QW";
